/**
 * Music-theory Unicode glyphs that screen readers announce inconsistently
 * (or with the literal Unicode name like "music flat sign"). See
 * {@link ./theory-glyphs.tsx} for the visible-text JSX rendering pattern.
 */
/** The one table of glyphs and their words; `TheoryGlyphs` reads it too */
export const spokenGlyphs: Record<string, string> = {
  /** A degree's double accidentals (melody toolkit M3): "double flat 7", "double sharp 5" */
  '𝄫': 'double flat',
  '𝄪': 'double sharp',
  '♭': 'flat',
  '♯': 'sharp',
  '°': 'diminished',
  /** The vocal lexicon writes deviations as "−28 ¢": a screen reader would say "minus sign" and "cent sign" */
  '−': 'minus',
  '¢': 'cents',
}

/**
 * Convert music-theory text with Unicode glyphs into spoken-language form
 * for string contexts (`title=`, `aria-label=`). Use {@link TheoryGlyphs}
 * for visible-text contexts.
 *
 * @example
 *   spokenText('♭VII comes from Mixolydian')
 *   // → 'flat VII comes from Mixolydian'
 *   spokenText('♯IV°')
 *   // → 'sharp IV diminished'
 */
export const spokenText = (text: string): string => {
  let result = text
  for (const [glyph, spoken] of Object.entries(spokenGlyphs)) {
    result = result.split(glyph).join(` ${spoken} `)
  }
  return result
    .replace(/\s+/g, ' ')
    .replace(/ ([.,;:!?])/g, '$1')
    .trim()
}
